import type { Hint } from "./types";

export function evaluateGuess(
  solution: readonly number[],
  guess: readonly number[],
): { correct_placed: number; correct_misplaced: number } {
  if (solution.length !== guess.length) {
    throw new Error(
      `Solution length ${solution.length} !== guess length ${guess.length}`,
    );
  }

  let correct_placed = 0;
  const solutionRemaining: number[] = [];
  const guessRemaining: number[] = [];

  for (let i = 0; i < solution.length; i++) {
    if (solution[i] === guess[i]) {
      correct_placed++;
    } else {
      solutionRemaining.push(solution[i]);
      guessRemaining.push(guess[i]);
    }
  }

  let correct_misplaced = 0;
  const solutionCounts: Map<number, number> = new Map();
  for (const d of solutionRemaining) {
    solutionCounts.set(d, (solutionCounts.get(d) ?? 0) + 1);
  }

  for (const d of guessRemaining) {
    const count = solutionCounts.get(d) ?? 0;
    if (count > 0) {
      correct_misplaced++;
      solutionCounts.set(d, count - 1);
    }
  }

  return { correct_placed, correct_misplaced };
}

export function checkCandidate(
  candidate: readonly number[],
  hints: readonly Hint[],
): boolean {
  for (const hint of hints) {
    const { correct_placed, correct_misplaced } = evaluateGuess(
      candidate,
      hint.digits,
    );
    if (
      correct_placed !== hint.correct_placed ||
      correct_misplaced !== hint.correct_misplaced
    ) {
      return false;
    }
  }
  return true;
}
